import React from 'react'
import CodesToolbarButtons from './CodesToolbarButtons'
import FilterGestion from '../../Includes/Filter/FilterGestion'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  SET_FILTERS_PAGE
} from '../../../Redux/Actions/Filters'

const CodesToolbarMobile = ({ setPage }) => {
  const dispatch = useDispatch()
  const codes = useSelector(state => state.codes.codes)
  const filters = useSelector(state => state.filters.pages)
  return (
    <div className="toolbar-actions-mobile toolbar-actions-mobile-codes">
      <CodesToolbarButtons/>
      <FilterGestion
        data={codes}
        label="codes"
        target="codes"
        setPage={setPage}
        state={filters.codes}
        setState={(value) => dispatch(SET_FILTERS_PAGE('codes', value))}
      />
    </div>
  )
}

export default CodesToolbarMobile
